import * as R from 'ramda'

import { GetEncodedDispensaryPromosQuery } from '../../../../graphql/camel'
import { restrictedFromUIInputCodes } from './config'
import { findRootPromoMatchingCode } from './findRootPromo'
import { PromoCodeUtilities } from './types'
import { identityPromise, sanitizeInput } from './util'

const isInRestrictedFromUIInputCodes: (code: string) => boolean = (code) =>
  restrictedFromUIInputCodes.includes(code)

export const isRestrictedFromInputGlobal = R.pipe(
  sanitizeInput,
  isInRestrictedFromUIInputCodes,
  identityPromise,
)

export const isRestrictedFromInputForRootPromos = (
  rootPromos: NonNullable<
    GetEncodedDispensaryPromosQuery['getEncodedDispensaryPromos']
  >['rootPromos'],
): PromoCodeUtilities['isCodeRestrictedFromUIInput'] => {
  const isRootPromoCode = R.pipe(
    findRootPromoMatchingCode(rootPromos),
    R.andThen(R.complement(R.isNil)),
  )

  return R.pipe(
    sanitizeInput,
    (input) => [input, isInRestrictedFromUIInputCodes(input)] as const,
    async ([input, isRestricted]) => isRestricted || (await isRootPromoCode(input)),
  )
}
